import { UrlMaker } from './../../commons/url-maker';
import { CmsObject } from './../../model/cmsobject';
import { SubscriptionTokenMode, IsoCountryCode, FunctionalityGroup, EditionCode } from './../../model/configuration';
import { IndustryCalType, IndustryModuleCode, IndustryProductID, OptionAvailability } from './../../model/industry';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from './../../../environments/environment';
import { Feature, OptionInfo, AccordionElement } from 'src/app/model/feature';
import { IndustryPurchasedInfo, CalTypeObject, IndustryCal, IndustryDescription } from 'src/app/model/industry';
import { ItemsAdministrativeInfo } from 'src/app/model/configuration';
import { OperationResult } from '@tb/auth';
import { CmsService } from './cms.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { GraphElement } from 'src/app/model/graphElement';
import { FragmentStatus } from 'src/app/industryeditor/models/industry-fragment';
import { ContractDetails } from 'src/app/model/contractDetails';
import { Mode } from 'src/app/model/subscription';

@Injectable({
    providedIn: 'root',
})
export class ConfigurationService {
    public current: IndustryDescription;

    public backToProductConfiguration: boolean = false;
    private back = new BehaviorSubject<boolean>(this.backToProductConfiguration);
    currentBack = this.back.asObservable();

    public resellerCode: string;
    public country: string;
    public loginID: string;
    public optFeatureSelected: Feature[] = [];
    public optCountableFeatureSelected: Feature[] = [];
    public selectedOptionInfo: OptionInfo[] = [];
    public industry_Cal: Array<IndustryCal> = new Array<IndustryCal>();
    public industry_Cal$ = new Subject<IndustryCal>();
    public atLeastOneIncompSelected: boolean = false;
    tempGraphElement: GraphElement[] = [];

    constructor(
        private http: HttpClient,
        public cmsService: CmsService,
        private workflow: WorkFlowService,
        private variable: TranslatedVariables
    ) {}

    goBack() {
        this.back.next(true);
    }

    public async getAllIndustriesNamesList(culture: string): Promise<CmsObject[]> {
        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.industriesServiceUrl)
            .appendSegment('getallindustriesnameslist')
            .appendSegment(culture)
            .toString();

        return this.http.get<CmsObject[]>(url).toPromise();
    }

    public async getallstdeditionindustries(language: string): Promise<OperationResult> {
        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.storeApiUrl)
            .appendSegment('getallstdeditionindustries')
            .appendSegment(language)
            .toString();

        return this.http.get<OperationResult>(url).toPromise();
    }
    // --------------------------------------------------------------------------------
    //[HttpPost("api/getmulticompanynr/")]
    public async getmulticompanynr(
        masterSubscriptionKey: string,
        productID: string,
        codiceTitolare: string,
        codiceCliente: string,
        matricola: string,
        provider?: string
    ): Promise<OperationResult> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('getmulticompanynr');

        if (provider) url.appendParameter('provider', provider);
        const jobj = {
            masterSubscriptionKey: masterSubscriptionKey,
            productID: productID,
            codiceTitolare: codiceTitolare,
            codiceCliente: codiceCliente,
            matricola: matricola,
        };
        return this.http.post<OperationResult>(url.toString(), JSON.stringify(jobj), { headers: headers }).toPromise();
    }

    public async getamazonindustries(language: string, edition: string, amzModulecode: string): Promise<OperationResult> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('getamazonindustries').toString();

        const jobj = {
            language: language,
            edition: edition,
            amzModulecode: amzModulecode,
        };
        return this.http.post<OperationResult>(url, JSON.stringify(jobj), { headers: headers }).toPromise();
    }

    public async getmagowebindustries(language: string, edition: string): Promise<OperationResult> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('getmagowebindustries').toString();

        const jobj = {
            language: language,
            edition: edition,
        };
        return this.http.post<OperationResult>(url, JSON.stringify(jobj), { headers: headers }).toPromise();
    }

    public async getContractsByCodiceTitolare(accountname: string, partnercode: string): Promise<OperationResult> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('getContractsByCodiceTitolare').toString();

        const jobj = {
            accountname: accountname,
            partnercode: partnercode,
        };
        return this.http.post<OperationResult>(url, JSON.stringify(jobj), { headers: headers }).toPromise();
    }

    public async isFavouriteCourse(accountname: string, coursename: string): Promise<OperationResult> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('isFavouriteCourse').toString();
        const jobj = {
            accountname: accountname,
            coursename: coursename,
        };
        return this.http.post<OperationResult>(url, JSON.stringify(jobj), { headers: headers }).toPromise();
    }

    public async getAllFavouriteCoursesByLogin(accountname: string): Promise<OperationResult> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.storeApiUrl)
            .appendSegment('getAllFavouriteCoursesByLogin')
            .toString();
        const jobj = {
            accountname: accountname,
        };
        return this.http.post<OperationResult>(url, JSON.stringify(jobj), { headers: headers }).toPromise();
    }

    public async AddFavouriteCourse(accountname: string, coursename: string): Promise<OperationResult> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('addFavouriteCourse').toString();
        const jobj = {
            accountname: accountname,
            coursename: coursename,
        };
        return this.http.post<OperationResult>(url, JSON.stringify(jobj), { headers: headers }).toPromise();
    }

    public async DeleteFavouriteCourse(accountname: string, coursename: string): Promise<OperationResult> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('deleteFavouriteCourse').toString();
        const jobj = {
            accountname: accountname,
            coursename: coursename,
        };
        return this.http.post<OperationResult>(url, JSON.stringify(jobj), { headers: headers }).toPromise();
    }

    public async attivazioneZContratto(
        element: ContractDetails,
        userRegionalSettings: string,
        userLanguage: string,
        currentAccountLogged: string,
        instanceKey: string
    ): Promise<OperationResult> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('attivazioneZContratto').toString();
        const jobj = {
            codiceTitolare: element.CodiceTitolare,
            codiceCliente: element.CodiceCliente,
            matricola: element.Matricola,
            idFlusso: element.IdFlusso,
            productVersion: '', //productVersion
            instanceKey: instanceKey, // a meno di quella selezionata dai brasiliani
            currentAccountLogged: currentAccountLogged, //per verifica token autenticazione,
            subscriptionMode: Mode.rtm.toString(),
            userRegionalSettings: userRegionalSettings,
            userLanguage: userLanguage,
            nazioneCliente: element.NazioneCliente,
        };
        console.log(jobj);
        return this.http.post<OperationResult>(url, JSON.stringify(jobj), { headers: headers }).toPromise();
    }

    public async getAllSupportedISOCountryCode(culture: string): Promise<IsoCountryCode[]> {
        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.industriesServiceUrl)
            .appendSegment('getallsupportedisocountrycode')
            .appendSegment(culture)
            .toString();

        return this.http.get<IsoCountryCode[]>(url).toPromise();
    }

    public async getAvailableFunctionalityGroups(): Promise<FunctionalityGroup[]> {
        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.industriesServiceUrl)
            .appendSegment('getallfragmentgroups')
            .toString();

        return this.http.get<FunctionalityGroup[]>(url).toPromise();
    }

    public async getAvailableCalType(): Promise<OperationResult> {
        return this.http.get<OperationResult>(environment.settings.storeApiUrl + 'getCalType/').toPromise();
    }

    public async getAllInstances(
        subtypeSelected: string,
        industryCode: string,
        accountNameForOnPremFilter: string = ''
    ): Promise<OperationResult> {
        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.storeApiUrl)
            .appendSegment('getInstancesList')
            .appendSegment(subtypeSelected)
            .appendSegment(industryCode)
            .appendSegment(accountNameForOnPremFilter)
            .toString();
        return this.http.get<OperationResult>(url).toPromise();
    }

    // --------------------------------------------------------------------------------
    //[HttpGet("api/getProvisioningSubscriptionTokenMode/{restricted}/{accountName}")]
    public async getAvailableSubscriptionTokenMode(restrictedList: boolean, accountName: string): Promise<SubscriptionTokenMode[]> {
        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.storeApiUrl)
            .appendSegment('getProvisioningSubscriptionTokenMode')
            .appendSegment(restrictedList.toString())
            .appendSegment(accountName)
            .toString();

        return this.http.get<SubscriptionTokenMode[]>(url).toPromise();
    }

    public async loadIndustrybyModuleCode(
        language: string,
        moduleCode: string,
        versioning: string,
        accountName: string,
        productRelease: string,
        isTester: string,
        isModifyingStatus: string,
        productID: string
    ): Promise<OperationResult> {
        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.storeApiUrl)
            .appendSegment('getIndustry')
            .appendSegment(language)
            .appendSegment(moduleCode)
            .appendSegment(versioning)
            .appendSegment(accountName)
            .appendSegment(productRelease)
            .appendSegment(isTester)
            .appendSegment(isModifyingStatus)
            .appendSegment(productID)
            .toString();

        return this.http.get<OperationResult>(url).toPromise();
    }

    public filterFeatureByCountryAndSelected(features: Feature[], countrySelected: string, industryCode: string) {
        let selectedFeatures: Feature[] = [];
        if (countrySelected == 'none') return features;

        for (var i = 0; i < features.length; i++) {
            let f = features[i];
            // if (industryCode === IndustryModuleCode.CART && !f.Selected) continue;

            let allowIsoCountries = this.listToArray(f.AllowISO, ',');
            let denyIsoCountries = this.listToArray(f.DenyISO, ',');
            if (
                (allowIsoCountries.length == 0 || allowIsoCountries.findIndex((x) => x == countrySelected) != -1) &&
                (denyIsoCountries.length == 0 ||
                    (denyIsoCountries.length != 0 && denyIsoCountries.findIndex((x) => x == countrySelected) == -1))
            ) {
                selectedFeatures.push(f);
            }
        }
        return selectedFeatures;
    }

    listToArray(fullString, separator) {
        var fullArray = [];
        if (fullString && fullString !== undefined && fullString.length > 0) {
            if (fullString.indexOf(separator) == -1) {
                fullArray.push(fullString);
            } else {
                fullArray = fullString.split(separator).map((item: string) => item.trim());
            }
        }
        return fullArray;
    }

    public async getInfrastructItems(culture: string, accountName: string, productID: string): Promise<OperationResult> {
        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.storeApiUrl)
            .appendSegment('ALaCarte')
            .appendSegment('infrastructitems')
            .appendSegment(culture)
            .appendSegment(accountName)
            .appendSegment(productID)
            .toString();
        return this.http.get<OperationResult>(url).toPromise();
    }

    public async getProductCodeLatestRelease(
        productCode: string,
        resellerCode: string,
        subMode: string,
        selectedCountry: string,
        subscriptionKey: string
    ) {
        const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('getProductVersion').toString();

        let headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: environment.auth.authToken });

        const jobj = {
            productCode: productCode,
            resellerCode: resellerCode,
            subMode: subMode,
            selectedCountry: selectedCountry,
            subscriptionKey: subscriptionKey,
        };
        return this.http
            .post<OperationResult>(url, JSON.stringify(jobj), {
                headers: headers,
            })
            .toPromise();
    }

    public getLatestIndustryVersion(moduleCode: string, productID: string): Promise<string> {
        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.industriesServiceUrl)
            .appendSegment('getLatestVersion')
            .appendSegment(moduleCode)
            .appendSegment(productID)
            .toString();

        let headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: environment.auth.authToken });

        return this.http.get<string>(url, { headers: headers }).toPromise();
    }

    private getAvailableCalTypes(
        language: string,
        moduleCode: string,
        editionCode: string,
        version: string,
        productRelease: string,
        isTester: string,
        isModifyingStatus: string,
        productID: string
    ): Promise<CalTypeObject[]> {
        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.industriesServiceUrl)
            .appendSegment('getallcaltype')
            .appendSegment(language)
            .appendSegment(editionCode)
            .appendSegment(moduleCode)
            .appendSegment(version)
            .appendSegment(productRelease)
            .appendSegment(isTester)
            .appendSegment(isModifyingStatus)
            .appendSegment(productID)
            .toString();
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.get<CalTypeObject[]>(url, { headers: headers }).toPromise();
    }

    public async getGraph(
        accountName: string,
        language: string,
        moduleCode: string,
        industryVersione: string,
        productRelease: string,
        isTester: string,
        isModifyingStatus: string,
        productID: string
    ): Promise<OperationResult> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: environment.auth.authToken });

        const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('getDependecyGraph').toString();

        const jobj = {
            language: language,
            accountName: accountName,
            moduleCode: moduleCode,
            industryVersion: industryVersione,
            productRelease: productRelease,
            isTester: isTester,
            isModifyingStatus: isModifyingStatus,
            productID: productID,
        };
        return this.http.post<OperationResult>(url, JSON.stringify(jobj), { headers: headers }).toPromise();
    }

    // public async getDiscountInfo(industryInfo: IndustryPurchasedInfo, custSupp: string) {
    //     let headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: environment.auth.authToken });

    //     const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('getItemsDiscount').toString();

    //     const jobj = {
    //         authToken: environment.auth.authToken,
    //         custSupp: custSupp,
    //         industry: industryInfo,
    //     };
    //     return this.http.post<OperationResult>(url, JSON.stringify(jobj), { headers: headers }).toPromise();
    // }
    // public async getMLUDiscountInfo(industryInfo: IndustryPurchasedInfo, custSupp: string) {
    //     let headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: environment.auth.authToken });

    //     const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('getMLUItemsDiscount').toString();

    //     const jobj = {
    //         authToken: environment.auth.authToken,
    //         custSupp: custSupp,
    //         industry: industryInfo,
    //     };
    //     return this.http.post<OperationResult>(url, JSON.stringify(jobj), { headers: headers }).toPromise();
    // }

    async getCalTypes(
        language: string,
        moduleCode: string,
        editionCode: string,
        version: string,
        productRelease: string,
        isTester: string,
        isModifyingStatus: string,
        productID: string
    ) {
        let object: any = this.industry_Cal.find((x) => x.industryCode == moduleCode && x.editionCode == editionCode);

        if (object) return;

        let list: CalTypeObject[] = await this.getAvailableCalTypes(
            language.toLowerCase(),
            moduleCode,
            editionCode,
            version,
            productRelease,
            isTester,
            isModifyingStatus,
            productID
        );

        let a: IndustryCal = new IndustryCal();
        a.industryCode = moduleCode;
        a.editionCode = editionCode;
        a.caltypes = list;
        this.industry_Cal.push(a);
        this.industry_Cal$.next(a);
    }

    getIndustryCalTotalNumber(industryCode: string) {
        if (this.industry_Cal.length == 0) return 0;

        let index = this.industry_Cal.findIndex((x) => x.industryCode == industryCode);
        if (index == -1) return;

        let currentIndustry = this.industry_Cal[index];
        let nr: number = 0;

        currentIndustry.caltypes.forEach((element) => {
            if (element.CalType == IndustryCalType.CalFull) {
                nr = nr + element.NrCalBuyed;
            }
        });
        return nr;
    }

    getIndustryTotalCalAmount(industry: IndustryPurchasedInfo) {
        let totalAmount = 0;
        let partialAmount = 0;
        for (let y = 0; y < industry.caltypes.length; y++) {
            partialAmount = 0;
            let caltype = industry.caltypes[y];
            let currentEditionPriceRanges = industry.priceRanges.filter(
                (x) => x.EditionCode == industry.Edition.EditionCode && x.ModuleCode == industry.ModuleCode
            );
            for (let i = currentEditionPriceRanges.length - 1; i >= 0; i--) {
                let range = currentEditionPriceRanges[i];
                if (range.ObjectType != caltype.CalType) continue;
                if (caltype.NrCalBuyed >= range.MinCalNr) {
                    partialAmount = caltype.NrCalBuyed * range.Price;
                    break;
                }
            }
            totalAmount = totalAmount + partialAmount;
        }
        // per ogni tipo di cal moltiplico il prezzo per il numero
        return totalAmount;
    }

    public getIndustryCurrencySymbol(price: ItemsAdministrativeInfo) {
        return !price ? 'n.d.' : price.Currency == 'euro' ? '€' : price.Currency;
    }

    public getNrOfUserSelected(feature: Feature) {
        let optInfo = this.selectedOptionInfo.find((x) => x.optionID == feature.OptionID);
        if (!optInfo) return;
        return optInfo.nrOfUser;
    }

    public createAccordionElement(tmp: Feature[]) {
        let currentModule: string;
        let aList: AccordionElement[] = [];
        tmp.forEach((element) => {
            let aElement: AccordionElement = new AccordionElement();
            aElement.status = element.Status;
            aElement.fragment = element.Fragment;
            let listElement = aList.find((x) => x.module.Description == currentModule);
            if (listElement == undefined) return;
            listElement.funtionlities.push(element);
            let index: number = aList.findIndex((x) => x.module.Description == aElement.module.Description);
            aList.splice(index, 1);
            aList.push(listElement);
            // }
        });

        return aList;
    }

    public getIndustrySelectedRange(industry: IndustryPurchasedInfo) {
        //prendo quello delle calFull
        if (!industry.priceRanges) return null;
        for (let y = 0; y < industry.caltypes.length; y++) {
            let caltype = industry.caltypes[y];
            let currentEditionPriceRanges = industry.priceRanges.filter(
                (x) =>
                    x.EditionCode.toLowerCase() == industry.Edition.EditionCode.toLowerCase() &&
                    x.ModuleCode.toLowerCase() == industry.ModuleCode.toLowerCase()
            );

            for (let i = currentEditionPriceRanges.length - 1; i >= 0; i--) {
                let range = currentEditionPriceRanges[i];
                if (range.ObjectType != caltype.CalType) continue;
                if (industry.productID == IndustryProductID.MW) return range;
                else {
                    if (caltype.NrCalBuyed >= range.MinCalNr) {
                        return range;
                    }
                }
            }
        }
    }
    public getOptionalFeature(features: Feature[], selectedEdition: string) {
        let list: Feature[] = [];
        features.forEach((f) => {
            for (let i = 0; i < f.Options.length; i++) {
                let opt = f.Options[i];

                if (opt.edition.toLowerCase() != selectedEdition) continue;
                if (
                    opt.availability.toLowerCase() == OptionAvailability.OPTIONAL ||
                    opt.availability.toLowerCase() == OptionAvailability.STANDALONE
                )
                    list.push(f);
            }
        });
        return list;
    }

    public getPptFeature(features: Feature[], selectedEdition: string) {
        let list: Feature[] = [];
        features.forEach((f) => {
            for (let i = 0; i < f.Options.length; i++) {
                let opt = f.Options[i];

                if (opt.edition.toLowerCase() != selectedEdition) continue;
                if (opt.availability.toLowerCase() == OptionAvailability.PPT) list.push(f);
            }
        });
        return list;
    }

    public getCountableFeature(features: Feature[], selectedEdition: string) {
        let list: Feature[] = [];
        features.forEach((f) => {
            for (let i = 0; i < f.Options.length; i++) {
                let opt = f.Options[i];

                if (opt.edition.toLowerCase() != selectedEdition) continue;
                if (opt.availability.toLowerCase() == OptionAvailability.COUNT) list.push(f);
            }
        });
        return list;
    }

    public async getTotalAmount(industryInfo: IndustryPurchasedInfo, roundedAmount: boolean) {
        let totalIndustryAmount = 0;
        let callFullObj = industryInfo.caltypes.find((x) => x.CalType == 1 && x.EditionCode == industryInfo.Edition.EditionCode);
        if (!callFullObj) return 0;
        let moduleCodes: string[] = industryInfo.ModuleCode.split('-');
        let industryCode = moduleCodes.length > 1 ? moduleCodes[1] : moduleCodes[0];
        //magoWeb ha un suo modo di calcolo
        if (industryInfo.productID == IndustryProductID.MW) {
            totalIndustryAmount = Math.round(industryInfo.totalGrossAmount);
            return totalIndustryAmount;
        } else {
            if (industryCode.toLowerCase() != IndustryModuleCode.CART.toLowerCase()) {
                let priceRange = industryInfo.priceRanges.find(
                    (x) =>
                        x.ModuleCode.toLowerCase() == industryCode.toLowerCase() &&
                        x.EditionCode.toLowerCase() == industryInfo.Edition.EditionCode.toLowerCase()
                );
                //calcolo il totale delle cal full
                totalIndustryAmount = priceRange.Price * callFullObj.NrCalBuyed;
            } else {
                //aggiungo i moduli obbligatori
                for (let i = 0; i < industryInfo.SelectedFeatures.length; i++) {
                    let feature = industryInfo.SelectedFeatures[i];
                    let f: OptionInfo = industryInfo.OptionalFeaturesOptionInfo.find(
                        (x) => x.fragment.toLowerCase() == feature.Fragment.toLowerCase()
                    );
                    if (!f) continue;
                    let partialOptionAmount = f.price * f.nrOfUser;
                    totalIndustryAmount += partialOptionAmount * callFullObj.NrCalBuyed;
                }
            }
            //calcolo il valore delle feature opzionali aggiunte
            let totalOptionAmount = 0;

            for (let i = 0; i < industryInfo.OptionalFeatures.length; i++) {
                let feature = industryInfo.OptionalFeatures[i];
                let option = feature.Options.find(
                    (x) =>
                        x.availability.toLowerCase() != OptionAvailability.OPTIONAL &&
                        x.edition.toLowerCase() == industryInfo.Edition.EditionCode.toLowerCase()
                );
                if (option) continue;
                let f: OptionInfo = industryInfo.OptionalFeaturesOptionInfo.find(
                    (x) => x.fragment.toLowerCase() == feature.Fragment.toLowerCase()
                );
                if (!f) continue;
                let partialOptionAmount = f.price * f.nrOfUser;
                totalOptionAmount += partialOptionAmount;
            }

            //calcolo il valore delle feature standAlone aggiunte
            let totalStandAloneElement = 0;

            for (let i = 0; i < industryInfo.OptionalFeatures.length; i++) {
                let feature = industryInfo.OptionalFeatures[i];

                let option = feature.Options.find(
                    (x) =>
                        x.availability.toLowerCase() != OptionAvailability.STANDALONE &&
                        x.edition.toLowerCase() == industryInfo.Edition.EditionCode.toLowerCase()
                );
                if (option) continue;

                let f: OptionInfo = industryInfo.OptionalFeaturesOptionInfo.find(
                    (x) => x.fragment.toLowerCase() == feature.Fragment.toLowerCase()
                );

                if (!f) continue;
                totalStandAloneElement = f.price * f.nrOfUser;
            }

            let totalCountableAmount = 0;

            for (let i = 0; i < industryInfo.CountableFeatures.length; i++) {
                let feature = industryInfo.CountableFeatures[i];
                let f: OptionInfo = industryInfo.OptionalFeaturesOptionInfo.find(
                    (x) => x.fragment.toLowerCase() == feature.Fragment.toLowerCase()
                );
                if (!f) continue;
                let partialCountableAmount = f.price * f.nrOfUser;
                totalCountableAmount = totalCountableAmount + partialCountableAmount;
            }

            let totalGrossAmount: number =
                totalIndustryAmount + totalOptionAmount * callFullObj.NrCalBuyed + totalStandAloneElement + totalCountableAmount;
            return roundedAmount ? Math.round(totalGrossAmount) : totalGrossAmount;
        }
    }
    public setCalFullNr(nr: number, caltypes: CalTypeObject[]) {
        if (!caltypes || caltypes.length == 0) return;
        let callFullObj = caltypes.find((x) => x.CalType == 1);
        callFullObj.NrCalBuyed = nr; //devo trasformarlo in n
        this.industry_Cal$.next();
    }

    public getStandardFeature(
        features: Feature[],
        industry: IndustryDescription,
        industryPurchInfo: IndustryPurchasedInfo,
        editionCode: string
    ) {
        let selectedFeatures: Feature[] = [];
        let selectedFeaturesOptionInfo: OptionInfo[] = [];
        //this.optFeatureSelected = [];
        for (var i = 0; i < features.length; i++) {
            let f = features[i];
            let filtered = f.Options.filter((x) => x.edition.toLowerCase() == editionCode && x.availability == OptionAvailability.ALWAYS);
            let price: number = 0;
            this.getFeaturePrice(industry, f, editionCode);
            if (filtered.length > 0) {
                let t: OptionInfo = new OptionInfo();
                t.selectedEdition = editionCode;
                t.price = price;
                t.optionID = f.OptionID;
                t.fragment = f.Fragment;
                t.nrOfUser = f.CurrNrOfUser;
                let exists =
                    selectedFeaturesOptionInfo.findIndex(
                        (x) => x.fragment.toLowerCase() == t.fragment.toLowerCase() && x.selectedEdition.toLowerCase() == editionCode
                    ) > -1;
                if (!exists) {
                    selectedFeaturesOptionInfo.push(t);
                    //this.optFeatureSelected.push(f);
                }
                f.isChecked = true;
                selectedFeatures.push(f);
            }
        }
        this.selectedOptionInfo = selectedFeaturesOptionInfo;
        industryPurchInfo.SelectedFeaturesOptionInfo = selectedFeaturesOptionInfo;
        return selectedFeatures;
    }

    getFeaturePrice(industry: IndustryDescription, feature: Feature, editionCode: string) {
        let price: ItemsAdministrativeInfo = industry.PriceRanges.find(
            (x) => x.ModuleCode == feature.OptionID && x.EditionCode.toLowerCase() == editionCode.toLowerCase()
        );

        if (price == undefined) return 0;
        return price.Price;
    }

    public getSelectedOptionInfo(feature: Feature) {
        let optInfo = this.selectedOptionInfo.find((x) => x.optionID == feature.OptionID);
        if (!optInfo) return '0';
        return optInfo.price;
    }
    //devo togliere dalla currentIndustry tutte le feature phaseout non presenti nella configurazione
    public purgePhaseOutFeatures(features: Feature[]) {
        features.forEach((element) => {
            if (element.Status === FragmentStatus.PhaseOut && (element.isChecked == undefined || element.isChecked == false)) {
                let index = features.findIndex((x) => x.Fragment == element.Fragment);
                if (index > -1) features.splice(index, 1);
            }
        });
    }

    async getFunctionalityGroups(
        selectedFeature: Feature[],
        optionalFeature: Feature[],
        showAlwaysFeatureToo: boolean,
        editionCode: string
    ) {
        let data: FunctionalityGroup[] = await this.getAvailableFunctionalityGroups();
        if (data === null || data === undefined) {
            return;
        }
        let functionalities = data.filter((x) => x.ParentGroupCode.length == 0);
        let sortedfunctionalities = functionalities.sort((a, b) => a.GroupPos - b.GroupPos);
        //
        sortedfunctionalities.forEach((element) => {
            let selectedFeatures: Feature[] = this.filterFeaturesByGroups(
                element.GroupCode,
                selectedFeature,
                showAlwaysFeatureToo,
                editionCode
            );
            let optionalFeatures: Feature[] = this.filterFeaturesByGroups(
                element.GroupCode,
                optionalFeature,
                showAlwaysFeatureToo,
                editionCode
            );
            if (!element.Features) element.Features = [];

            if (selectedFeatures.length > 0) element.Features.push(...selectedFeatures);
            if (optionalFeatures.length > 0) element.Features.push(...optionalFeatures);
        });

        data.forEach((element) => {
            if (element.ParentGroupCode.length > 0) {
                let f = sortedfunctionalities.find((x) => x.GroupCode.toLowerCase() == element.ParentGroupCode.toLowerCase());
                if (f) {
                    if (f.Children == null) f.Children = [];
                    let selectedFeatures: Feature[] = this.filterFeaturesByGroups(
                        element.GroupCode,
                        selectedFeature,
                        showAlwaysFeatureToo,
                        editionCode
                    );
                    let optionalFeatures: Feature[] = this.filterFeaturesByGroups(
                        element.GroupCode,
                        optionalFeature,
                        showAlwaysFeatureToo,
                        editionCode
                    );
                    if (!element.Features) element.Features = [];
                    if (selectedFeatures.length > 0) element.Features.push(...selectedFeatures);
                    if (optionalFeatures.length > 0) element.Features.push(...optionalFeatures);
                    if (element.Features.length > 0) f.Children.push(element);
                }
            }
        });
        //
        let fragmentGroupDictionary = await this.cmsService.getAllFragmentGroupDictionary(this.workflow.getLanguageForCms());

        sortedfunctionalities.forEach((element) => {
            let index = fragmentGroupDictionary.findIndex((x) => x.ContentName == element.GroupCode + '_grouptitle');
            if (index == -1) element.Title = element.Name;
            else element.Title = fragmentGroupDictionary[index].ContentTranslation;

            let indexDetatils = fragmentGroupDictionary.findIndex((x) => x.ContentName == element.GroupCode + '_groupdetails');
            if (indexDetatils == -1) element.Details = element.Name;
            else element.Details = fragmentGroupDictionary[indexDetatils].ContentTranslation;
            if (element.Children == null) element.Children = [];
            element.Children.forEach((child) => {
                let index = fragmentGroupDictionary.findIndex((x) => x.ContentName == child.GroupCode + '_grouptitle');
                if (index == -1) child.Title = child.Name;
                else child.Title = fragmentGroupDictionary[index].ContentTranslation;

                let indexDetatils = fragmentGroupDictionary.findIndex((x) => x.ContentName == child.GroupCode + '_groupdetails');
                if (indexDetatils == -1) child.Details = child.Name;
                else child.Details = fragmentGroupDictionary[indexDetatils].ContentTranslation;
            });
        });
        return sortedfunctionalities;
    }

    async getAlwaysFunctionalityGroups(selectedFeature: Feature[], showAlwaysFeatureToo: boolean, editionCode: string) {
        let data: FunctionalityGroup[] = await this.getAvailableFunctionalityGroups();
        if (data === null || data === undefined) {
            return;
        }
        let functionalities = data.filter((x) => x.ParentGroupCode.length == 0);
        let sortedfunctionalities = functionalities.sort((a, b) => a.GroupPos - b.GroupPos);
        //
        sortedfunctionalities.forEach((element) => {
            let selectedFeatures: Feature[] = this.filterFeaturesByGroups(
                element.GroupCode,
                selectedFeature,
                showAlwaysFeatureToo,
                editionCode
            );
            if (!element.Features) element.Features = [];

            if (selectedFeatures.length > 0) element.Features.push(...selectedFeatures);
        });

        data.forEach((element) => {
            if (element.ParentGroupCode.length > 0) {
                let f = sortedfunctionalities.find((x) => x.GroupCode.toLowerCase() == element.ParentGroupCode.toLowerCase());
                if (f) {
                    if (f.Children == null) f.Children = [];
                    let selectedFeatures: Feature[] = this.filterFeaturesByGroups(
                        element.GroupCode,
                        selectedFeature,
                        showAlwaysFeatureToo,
                        editionCode
                    );
                    if (!element.Features) element.Features = [];
                    if (selectedFeatures.length > 0) element.Features.push(...selectedFeatures);
                    if (element.Features.length > 0) f.Children.push(element);
                }
            }
        });
        //
        let fragmentGroupDictionary = await this.cmsService.getAllFragmentGroupDictionary(this.workflow.getLanguageForCms());

        sortedfunctionalities.forEach((element) => {
            let index = fragmentGroupDictionary.findIndex((x) => x.ContentName == element.GroupCode + '_grouptitle');
            if (index == -1) element.Title = element.Name;
            else element.Title = fragmentGroupDictionary[index].ContentTranslation;

            let indexDetatils = fragmentGroupDictionary.findIndex((x) => x.ContentName == element.GroupCode + '_groupdetails');
            if (indexDetatils == -1) element.Details = element.Name;
            else element.Details = fragmentGroupDictionary[indexDetatils].ContentTranslation;
            if (element.Children == null) element.Children = [];
            element.Children.forEach((child) => {
                let index = fragmentGroupDictionary.findIndex((x) => x.ContentName == child.GroupCode + '_grouptitle');
                if (index == -1) child.Title = child.Name;
                else child.Title = fragmentGroupDictionary[index].ContentTranslation;

                let indexDetatils = fragmentGroupDictionary.findIndex((x) => x.ContentName == child.GroupCode + '_groupdetails');
                if (indexDetatils == -1) child.Details = child.Name;
                else child.Details = fragmentGroupDictionary[indexDetatils].ContentTranslation;
            });
        });
        return sortedfunctionalities;
    }

    private filterFeaturesByGroups(groupName: string, features: Feature[], showAlwaysFeatureToo: boolean, editionCode: string): Feature[] {
        let fSorted: Feature[] = [];
        if (!showAlwaysFeatureToo) {
            let f = features.filter((x) => x.GroupCode == groupName);
            f.forEach((element) => {
                element.isChecked = false;
                let option = element.Options.find(
                    (x) => x.edition.toLowerCase() == editionCode.toLowerCase() && x.availability != OptionAvailability.ALWAYS
                );
                if (option) fSorted.push(element);
            });
        } else fSorted = features.filter((x) => x.GroupCode == groupName);

        let sortedFeature = fSorted.sort((a, b) => a.Level - b.Level);
        return sortedFeature;
    }
    public checkIfAllPrerequisiteAreChecked(prerequisites: string[]) {
        if (prerequisites.length == 0) return true;
        for (let i = 0; i < prerequisites.length; i++) {
            let fragment = prerequisites[i];
            let index = this.optFeatureSelected.findIndex((x) => x.Fragment.toLowerCase() == fragment.toLowerCase());
            if (index == -1) return false;
        }
        return true;
    }
    public checkIfOneIncompatibilityIsChecked(incompatibilities: string[]) {
        if (incompatibilities.length == 0) return false;

        for (let i = 0; i < incompatibilities.length; i++) {
            let fragment = incompatibilities[i];
            let index = this.optFeatureSelected.findIndex((x) => x.Fragment.toLowerCase() == fragment.toLowerCase());
            if (index > -1) return true;
            continue;
        }
        return false;
    }

    showDialog(filteredFeatureByCountry: Feature[], featureDescription: string, prerequisites: string[], incompatibilities: string[]) {
        let popupBody: string = '';
        let prerequisitesList = '';
        for (let i = 0; i < prerequisites.length; i++) {
            let feature = filteredFeatureByCountry.find((x) => x.Fragment.toLowerCase() == prerequisites[i].toLowerCase());
            if (!feature) continue;
            prerequisitesList += feature.Description;
            if (i < prerequisites.length - 1) prerequisitesList += '; ';
        }

        if (this.workflow.languageIsItalian()) {
            popupBody =
                `Per utilizzare il modulo <b> ${featureDescription}</b> devi acquistare anche:<b> ` +
                prerequisitesList +
                `</b>.<br/> Abbiamo aggiornato la tua configurazione aggiungendo tutte le funzionalità necessarie per lavorare con ${featureDescription}`;
        } else {
            popupBody =
                `The <b> ${featureDescription}</b> module requires also: <b>` +
                prerequisitesList +
                `</b>.<br/> We have updated your configuration by adding all the functionality needed to work with ${featureDescription}`;
        }

        //devo andare a recuperare tutte le incompatibilità ed eventualmente dare un messaggio di errore
        if (incompatibilities.length > 0) {
            if (popupBody.length > 0) popupBody += '<br />';
            let incompatibilitiesList = '';

            for (let i = 0; i < incompatibilities.length; i++) {
                let feature = filteredFeatureByCountry.find((x) => x.Fragment.toLowerCase() == incompatibilities[i].toLowerCase());
                if (!feature) continue;
                incompatibilitiesList += feature.Description;
                if (i < incompatibilities.length - 1) incompatibilitiesList += '; ';
            }

            if (this.workflow.languageIsItalian()) {
                popupBody +=
                    `Il modulo <b>${featureDescription}</b> è <b>incompatibile</b> con: <b>` +
                    incompatibilitiesList +
                    `</b>. Pertanto se vuoi selezionare questo modulo devi prima <b> deselezionare ` +
                    incompatibilitiesList +
                    '</b>';
            } else {
                popupBody +=
                    `The <b>${featureDescription}</b> module is <b>incompatible</b> with:<b> ` + incompatibilitiesList <
                    +`></b>, so if you want to add this module, you have to <b> deselect  ` + incompatibilitiesList + '</b>';
            }
        }
        if (popupBody.length > 0) this.workflow.showMessage(this.variable.popupTitle, popupBody);
    }

    checkIncompatibilities(functionalitygroups: FunctionalityGroup[], incompatibilities: string[]) {
        let ok = false;
        for (let i = 0; i < incompatibilities.length; i++) {
            let incompatibility = incompatibilities[i];
            functionalitygroups.forEach((group) => {
                let optFeature: Feature = group.Features.find(
                    (x) => x.Fragment.toLowerCase() == incompatibility.toLowerCase() && x.isChecked == true
                );
                if (optFeature) {
                    ok = true;
                    return;
                } else {
                    //cerco nei figli
                    group.Children.forEach((childrenGroup) => {
                        let optFeature: Feature = childrenGroup.Features.find(
                            (x) => x.Fragment.toLowerCase() == incompatibility.toLowerCase() && x.isChecked == true
                        );
                        if (optFeature) {
                            ok = true;
                            return;
                        }
                    });
                }
            });
        }
        return ok;
    }
    setPrerequisitesSelected(
        functionalitygroups: FunctionalityGroup[],
        prerequisites: string[],
        edition: string,
        isTester: boolean,
        isModifyingStatus: boolean
    ) {
        prerequisites.forEach((prerequisite) => {
            functionalitygroups.forEach((group) => {
                let optFeature: Feature = isTester
                    ? group.Features.find((x) => x.Fragment.toLowerCase() == prerequisite.toLowerCase())
                    : isModifyingStatus
                    ? group.Features.find(
                          (x) =>
                              x.Fragment.toLowerCase() == prerequisite.toLowerCase() &&
                              (x.Status == FragmentStatus.Available || x.Status == FragmentStatus.PhaseOut)
                      )
                    : group.Features.find(
                          (x) => x.Fragment.toLowerCase() == prerequisite.toLowerCase() && x.Status == FragmentStatus.Available
                      );
                if (optFeature) {
                    optFeature.isChecked = true;
                    optFeature.IsMandatory = true;
                    if (optFeature.SelectedByUser) return;
                    optFeature.SelectedByUser = false;
                    this.manageOptionInfo(optFeature, edition);
                } else {
                    //cerco nei figli
                    group.Children.forEach((childrenGroup) => {
                        let optFeature: Feature = isTester
                            ? childrenGroup.Features.find((x) => x.Fragment.toLowerCase() == prerequisite.toLowerCase())
                            : isModifyingStatus
                            ? childrenGroup.Features.find(
                                  (x) =>
                                      x.Fragment.toLowerCase() == prerequisite.toLowerCase() &&
                                      (x.Status == FragmentStatus.Available || x.Status == FragmentStatus.PhaseOut)
                              )
                            : childrenGroup.Features.find(
                                  (x) => x.Fragment.toLowerCase() == prerequisite.toLowerCase() && x.Status == FragmentStatus.Available
                              );
                        if (optFeature) {
                            optFeature.isChecked = true;
                            optFeature.IsMandatory = true;
                            if (optFeature.SelectedByUser) return;
                            optFeature.SelectedByUser = false;
                            this.manageOptionInfo(optFeature, edition);
                        }
                    });
                }
            });
        });
    }

    manageOptionInfo(optFeature: Feature, edition: string) {
        if (optFeature != null) {
            //è selezionata una sua incompatibilità

            if (this.atLeastOneIncompSelected) {
                this.atLeastOneIncompSelected = false;
                return;
            }
            if (optFeature.isChecked) {
                let isCountable =
                    optFeature.Options.findIndex(
                        (x) => x.edition.toLowerCase() == edition && x.availability.toLowerCase() === OptionAvailability.COUNT
                    ) > -1;

                let isOptional =
                    optFeature.Options.findIndex(
                        (x) =>
                            x.edition.toLowerCase() == edition &&
                            (x.availability.toLowerCase() === OptionAvailability.OPTIONAL ||
                                x.availability.toLowerCase() === OptionAvailability.STANDALONE)
                    ) > -1;

                let isPPt =
                    optFeature.Options.findIndex(
                        (x) => x.edition.toLowerCase() == edition && x.availability.toLowerCase() === OptionAvailability.PPT
                    ) > -1;

                let t: OptionInfo = new OptionInfo();
                t.selectedEdition = edition;
                t.price = 0;
                t.optionID = optFeature.OptionID;
                t.fragment = optFeature.Fragment;
                t.nrOfUser = optFeature.CurrNrOfUser;

                if (isOptional) {
                    let index = this.optFeatureSelected.findIndex(
                        (x) =>
                            x.OptionID == optFeature.OptionID &&
                            x.Options.findIndex((y) => y.edition.toLowerCase() == edition.toLowerCase()) != -1
                    );
                    if (index == -1) {
                        this.optFeatureSelected.push(optFeature);
                    } else {
                        //potrebbe aver aumentato il numero degli utenti
                        this.optFeatureSelected.splice(index, 1, optFeature);
                    }

                    let of = this.selectedOptionInfo;
                    let indexopt = of.findIndex((x) => x.optionID == optFeature.OptionID);
                    if (indexopt == -1) {
                        this.selectedOptionInfo.push(t);
                    } else {
                        //potrebbe aver aumentato il numero degli utenti
                        this.selectedOptionInfo.splice(indexopt, 1, t);
                    }
                }
                if (isCountable) {
                    let index = this.optCountableFeatureSelected.findIndex(
                        (x) =>
                            x.OptionID == optFeature.OptionID &&
                            x.Options.findIndex((y) => y.edition.toLowerCase() == edition.toLowerCase()) != -1
                    );
                    if (index == -1) {
                        this.optCountableFeatureSelected.push(optFeature);
                    } else {
                        //potrebbe aver aumentato il numero degli utenti
                        this.optCountableFeatureSelected.splice(index, 1, optFeature);
                    }

                    let of = this.selectedOptionInfo;
                    let indexopt = of.findIndex((x) => x.optionID == optFeature.OptionID);
                    if (indexopt == -1) {
                        this.selectedOptionInfo.push(t);
                    } else {
                        //potrebbe aver aumentato il numero degli utenti
                        this.selectedOptionInfo.splice(indexopt, 1, t);
                    }
                }
            } else {
                this.removeFromSelectedFeature(optFeature, edition);
                this.removeFromSelectedOptionInfo(optFeature, edition);
            }
        }
    }
    removeChecked(feature: Feature, edition: string) {
        if (feature.IsMandatory) return;
        feature.isChecked = false;
        feature.SelectedByUser = false;
        let isCountable =
            feature.Options.findIndex(
                (x) => x.edition.toLowerCase() == edition && x.availability.toLowerCase() === OptionAvailability.COUNT
            ) > -1;
        feature.CurrNrOfUser = isCountable ? feature.CurrNrOfUser - 1 : 1;
    }
    async removePrerequisitesSelected(
        filteredFeatureByCountry: Feature[],
        edition: string,
        isModifyStatus: boolean,
        prerequisites: string[],
        featureDeselected: Feature,
        functionalitygroups: FunctionalityGroup[],
        isTester: boolean,
        isModifyingStatus: boolean
    ) {
        if (featureDeselected.IsMandatory) return;
        let alreadyShown: boolean = false;
        for (let i = 0; i < prerequisites.length; i++) {
            let prerequisite = prerequisites[i];
            //rimuovo quell'elelmento del grafo e aggiorno gli hint
            this.removeHint(prerequisite);
            let y = this.tempGraphElement.findIndex((x) => x.Fragment.toLowerCase() == prerequisite.toLowerCase());
            if (y == -1) continue;
            let graphElement = this.tempGraphElement[y];
            if (!graphElement) continue;
            if (graphElement.NReferences == 0) {
                functionalitygroups.forEach((group) => {
                    let optFeature: Feature = isTester
                        ? group.Features.find((x) => x.Fragment.toLowerCase() == prerequisite.toLowerCase())
                        : isModifyingStatus
                        ? group.Features.find(
                              (x) =>
                                  x.Fragment.toLowerCase() == prerequisite.toLowerCase() &&
                                  (x.Status == FragmentStatus.Available || x.Status == FragmentStatus.PhaseOut)
                          )
                        : group.Features.find(
                              (x) => x.Fragment.toLowerCase() == prerequisite.toLowerCase() && x.Status == FragmentStatus.Available
                          );
                    if (optFeature) {
                        optFeature.isChecked = false;
                        optFeature.IsMandatory = false;
                        if (optFeature.SelectedByUser) {
                            optFeature.IsMandatory = false;
                            optFeature.isChecked = true;
                        } else {
                            optFeature.SelectedByUser = false;
                        }
                        this.manageOptionInfo(optFeature, edition);
                        if (isModifyStatus) {
                            for (let i = 0; i < prerequisites.length; i++) {
                                let prerequisite = prerequisites[i];
                                let y = this.tempGraphElement.findIndex((x) => x.Fragment.toLowerCase() == prerequisite.toLowerCase());
                                if (y == -1) continue;
                                let graphElement = this.tempGraphElement[y];
                                if (!graphElement) continue;
                                if (graphElement.NReferences == 0) {
                                    optFeature.isChecked = true;
                                    optFeature.IsMandatory = false;
                                    optFeature.SelectedByUser = true;
                                    if (!alreadyShown) {
                                        this.showAlert(featureDeselected.Description, prerequisites, filteredFeatureByCountry);
                                        alreadyShown = true;
                                    }
                                }
                            }
                        }
                    } else {
                        //cerco nei figli
                        group.Children.forEach((childrenGroup) => {
                            let optFeature: Feature = isTester
                                ? childrenGroup.Features.find((x) => x.Fragment.toLowerCase() == prerequisite.toLowerCase())
                                : isModifyStatus
                                ? childrenGroup.Features.find(
                                      (x) =>
                                          x.Fragment.toLowerCase() == prerequisite.toLowerCase() &&
                                          (x.Status == FragmentStatus.Available || x.Status == FragmentStatus.PhaseOut)
                                  )
                                : childrenGroup.Features.find(
                                      (x) => x.Fragment.toLowerCase() == prerequisite.toLowerCase() && x.Status == FragmentStatus.Available
                                  );

                            if (optFeature) {
                                optFeature.isChecked = false;
                                optFeature.IsMandatory = false;
                                if (optFeature.SelectedByUser) {
                                    optFeature.IsMandatory = false;
                                    optFeature.isChecked = true;
                                } else {
                                    optFeature.SelectedByUser = false;
                                }
                                this.manageOptionInfo(optFeature, edition);
                                if (isModifyStatus) {
                                    for (let i = 0; i < prerequisites.length; i++) {
                                        let prerequisite = prerequisites[i];
                                        let y = this.tempGraphElement.findIndex(
                                            (x) => x.Fragment.toLowerCase() == prerequisite.toLowerCase()
                                        );
                                        if (y == -1) continue;
                                        let graphElement = this.tempGraphElement[y];
                                        if (!graphElement) continue;
                                        if (graphElement.NReferences == 0) {
                                            optFeature.isChecked = true;
                                            optFeature.IsMandatory = false;
                                            optFeature.SelectedByUser = true;

                                            if (!alreadyShown) {
                                                this.showAlert(featureDeselected.Description, prerequisites, filteredFeatureByCountry);
                                                alreadyShown = true;
                                            }
                                        }
                                    }
                                }
                            }
                        });
                    }
                });
            }
        }
    }
    showAlert(featureDescription: string, prerequisites: string[], filteredFeatureByCountry: Feature[]) {
        let popupBody: string = '';
        let prerequisitesList = '';
        for (let i = 0; i < prerequisites.length; i++) {
            let feature = filteredFeatureByCountry.find((x) => x.Fragment.toLowerCase() == prerequisites[i].toLowerCase());
            if (!feature) continue;
            prerequisitesList += feature.Description;
            if (i < prerequisites.length - 1) prerequisitesList += '; ';
        }

        if (this.workflow.languageIsItalian()) {
            popupBody =
                `ATTENZIONE! E' stato deselezionato il modulo:<b> ${featureDescription} </b> occorre deselezionare anche: <b>` +
                prerequisitesList +
                `</b> a meno che non siano moduli che utilizzate.`;
        } else {
            popupBody =
                `WARNING! <b>${featureDescription} </b> module has been removed from configuration, you have to deselect also the following
          prerequisites unless you use them :<b> ` +
                prerequisitesList +
                `</b>.`;
        }
        if (popupBody.length > 0) this.workflow.showMessage(this.variable.popupTitle, popupBody);
    }
    removeHint(fragment: string) {
        let index = this.tempGraphElement.findIndex((x) => x.Fragment.toLowerCase() == fragment.toLowerCase());
        let gElem = this.tempGraphElement[index];
        if (!gElem) return;
        if (gElem.NReferences == 0) return;
        else {
            this.tempGraphElement.splice(index, 1);
            gElem.NReferences = gElem.NReferences - 1;
            this.tempGraphElement.push(gElem);
        }
    }
    removeFromSelectedFeature(optFeature: Feature, selectedEdition: string) {
        let f = this.optFeatureSelected;
        let index = f.findIndex(
            (x) =>
                x.OptionID == optFeature.OptionID &&
                x.Options.findIndex((y) => y.edition.toLowerCase() == selectedEdition.toLowerCase()) != -1
        );
        if (index != -1) {
            f.splice(index, 1);
            this.optFeatureSelected = f;
        }
    }

    removeFromSelectedOptionInfo(optFeature: Feature, selectedEdition: string) {
        let t = this.selectedOptionInfo;
        let i = t.findIndex((x) => x.optionID == optFeature.OptionID && x.selectedEdition.toLowerCase() == selectedEdition.toLowerCase());
        if (i != -1) {
            t.splice(i, 1);
            this.selectedOptionInfo = t;
        }
    }
    addHint(graphElement: GraphElement) {
        let index = this.tempGraphElement.findIndex((x) => x.Fragment.toLowerCase() == graphElement.Fragment.toLowerCase());
        let gElem = this.tempGraphElement[index];
        if (!gElem) {
            //aggiungo l'originale
            graphElement.NReferences = 1;
            this.tempGraphElement.push(graphElement);
        } else {
            this.tempGraphElement.splice(index, 1);
            gElem.NReferences = gElem.NReferences + 1;
            this.tempGraphElement.push(gElem);
        }
    }
    setHintsForPrerequisites(graphElements: GraphElement[], prerequisites: string[]) {
        prerequisites.forEach((element) => {
            let graphElement = graphElements.find((x) => x.Fragment.toLowerCase() == element.toLowerCase());
            this.addHint(graphElement);
        });
    }

    public getMC01Price(productID: string, quotaPartePerc: number, nrOfUser: number, totalConfigurationAmount: number, MCGMPrice: number) {
        //per il calcolo della cgm di MW applico le regole di calcolo di M4
        /*
      ALGORITMO rivisto in data 11/03/2023 - Germano
      Definito MCGM il valore della CGM base (ITEM_FIRST_CGM)
      Definito mod(i) il valore dell’ i-esimo modulo della configurazione, che non sia né un'Extensions né la CGM base
      Definito ecgm(j) il valore della j-esima CGM extension
      Abbiamo, in generale:
      T_CONF = SUM(mod(i))                                  : valore della configurazione esclusi i moduli di cui sopra
      ecgm(j)      = F1(T_CONF)                             : valore della j-esima CGM extension(oggi F1 = 15 %)
      e quindi :
      1)     T_ECGM = SUM(ecgm(j))                           : valore totale di tutte le extension CGM
      2)     T_MULT = F2(T_CONF + T_ECGM + MCGM)             : valore finale della MultiCompany(oggi F2 = 50 %)
      3)     T_TEST = F3(T_CONF + T_ECGM + MCGM + T_MULT)    : valore finale della TEST
            T_BACKUP= F4(T_CONF + T_ECGM + MCGM + T_MULT)   : valore finale della BACKUP

      Nel seguito l'algoritmo quindi è esploso in tre fasi dove nelle fasi 1 e 2 le extensione ECGM e MULT vengono aggiunti all'array dei moduli disponibili per
      il applicare il calcolo delle MULT - TEST - BACKUP :
      1)     Calcolo dell'eventuale Extension CGM con aggiunta della stessa come modulo da usare nelle fasi successive
      2)     Calcolo dell'eventuale Extension MULTICOMPANY con aggiunta della stessa come modulo da usare nelle fasi successive
      3)     Calcolo dell'eventuale Extension TEST e BACKUP utilizzando quanto eventualmente calcolato per le extension di cui sopra
                                */
        //let mc01NrPay =  nrOfUser- 2; //
        let percent = productID == IndustryProductID.MC ? 100 - quotaPartePerc : quotaPartePerc;
        let totalWithoutMCG = totalConfigurationAmount - MCGMPrice;
        let mc01Price = ((totalWithoutMCG * percent) / 100) * nrOfUser;
        return mc01Price;
    }

    public getTotalBaseIndustryAmounts(currIndustryPurchInfo: IndustryPurchasedInfo, calfullNr: number) {
        this.setCalFullNr(+calfullNr, currIndustryPurchInfo.caltypes);
        let priceRange: ItemsAdministrativeInfo = this.getIndustrySelectedRange(currIndustryPurchInfo);
        if (!priceRange) return 0;
        return priceRange.Price * +calfullNr;
    }

    public getTotalOptionAmount(currIndustryPurchInfo: IndustryPurchasedInfo, calfullNr: number) {
        this.setCalFullNr(+calfullNr, currIndustryPurchInfo.caltypes);
        return this.getOptionAmount(currIndustryPurchInfo.Edition.EditionCode) * +calfullNr;
    }
    public getTotalStandaloneAmount(currIndustryPurchInfo: IndustryPurchasedInfo) {
        return this.getStandaloneAmount(currIndustryPurchInfo.Edition.EditionCode);
    }
    public getOptionalFeatureAmount(currIndustryPurchInfo: IndustryPurchasedInfo) {
        let totalOptionAmount = 0;
        this.optFeatureSelected.forEach((feature) => {
            let selectedOtption = feature.Options.find(
                (x) => x.edition.toLowerCase() == currIndustryPurchInfo.Edition.EditionCode.toLowerCase()
            );
            if (
                !selectedOtption ||
                selectedOtption.availability == OptionAvailability.ALWAYS ||
                selectedOtption.availability == OptionAvailability.STANDALONE
            )
                return;

            let optInfo = this.selectedOptionInfo.find((x) => x.optionID == feature.OptionID);
            if (!optInfo || !optInfo.optionID || optInfo.optionID.length == 0) return;

            let nrOfUser = optInfo.nrOfUser;
            let totalOptionalFeaturePrice = optInfo.price;
            totalOptionAmount = totalOptionAmount + totalOptionalFeaturePrice;
        });
        return Math.round(totalOptionAmount);
    }

    public getOptionAmount(selectedEdition: string) {
        let totalOptionAmount = 0;
        this.optFeatureSelected.forEach((feature) => {
            let selectedOtption = feature.Options.find((x) => x.edition.toLowerCase() == selectedEdition.toLowerCase());
            if (
                !selectedOtption ||
                selectedOtption.availability == OptionAvailability.ALWAYS ||
                selectedOtption.availability == OptionAvailability.STANDALONE
            )
                return;

            let optInfo = this.selectedOptionInfo.find((x) => x.optionID == feature.OptionID);
            if (!optInfo || !optInfo.optionID || optInfo.optionID.length == 0) return;

            let nrOfUser = optInfo.nrOfUser;
            let totalOptionalFeaturePrice = optInfo.price * nrOfUser;
            totalOptionAmount = totalOptionAmount + totalOptionalFeaturePrice;
        });
        return Math.round(totalOptionAmount);
    }

    public getStandaloneAmount(selectedEdition: string) {
        let totalOptionAmount = 0;
        this.optFeatureSelected.forEach((feature) => {
            let selectedOtption = feature.Options.find((x) => x.edition.toLowerCase() == selectedEdition.toLowerCase());
            if (!selectedOtption || selectedOtption.availability !== OptionAvailability.STANDALONE) return;

            let optInfo = this.selectedOptionInfo.find((x) => x.optionID == feature.OptionID);
            if (!optInfo || !optInfo.optionID || optInfo.optionID.length == 0) return;

            let nrOfUser = optInfo.nrOfUser;
            let totalStandaloneFeaturePrice = optInfo.price * nrOfUser;
            totalOptionAmount = totalOptionAmount + totalStandaloneFeaturePrice;
        });
        return Math.round(totalOptionAmount);
    }

    public getOptionCountableAmount() {
        let totalCountableOptionAmount = 0;
        this.optCountableFeatureSelected.forEach((feature) => {
            let optInfo = this.selectedOptionInfo.find((x) => x.optionID == feature.OptionID);
            if (!optInfo) return;
            let nrOfUser = optInfo.nrOfUser;
            let totalOptionalFeaturePrice = optInfo.price * nrOfUser;
            totalCountableOptionAmount = totalCountableOptionAmount + totalOptionalFeaturePrice;
        });
        return totalCountableOptionAmount;
    }
    public getTotalModuleAmount(currIndustryPurchInfo: IndustryPurchasedInfo) {
        return (
            currIndustryPurchInfo.industryBaseAmount +
            currIndustryPurchInfo.totalOptionalFeaturesAmount +
            currIndustryPurchInfo.totalCountableModuleAmount
        );
    }

    public getExtentionPrice(totalConfigurationAmount: number, extCGMPrice: number, item: ItemsAdministrativeInfo) {
        let referenceAmount = totalConfigurationAmount + extCGMPrice;
        if (!item || !item.Discount || item.Discount == 0) return referenceAmount;

        if (item.ProductID === IndustryProductID.MC) {
            //-	Per MagoCloud è invece lo sconto da applicare per fare in modo che cubi un det.to valore;
            let discount = (referenceAmount * item.Discount) / 100;
            return referenceAmount - discount;
        }
        if (item.ProductID === IndustryProductID.MW) {
            //-	Per Mago4 e MagoWeb lo sconto indicato in anagrafica = quanto cuba l’ext.;
            return (referenceAmount * item.Discount) / 100;
        }
    }

    public getCorrectEdition(industryCode: string, hasFlatPrice: boolean, editionSelected: string) {
        if (hasFlatPrice) return EditionCode.crt;
        if (industryCode === IndustryModuleCode.CART && !hasFlatPrice) {
            switch (editionSelected) {
                case EditionCode.std:
                    return EditionCode.crs;
                case EditionCode.prm:
                    return EditionCode.crp;
                case EditionCode.pro:
                    return EditionCode.crt;
                case EditionCode.ent:
                    return EditionCode.cre;
                default:
                    return EditionCode.crt;
            }
        } else return editionSelected;
    }
}
